import { computed } from "vue";
import { useRoute } from "vue-router";

/**
 * Composable for determining if the current view is in consolidated mode.
 *
 * Consolidated mode shows data across all companies for an account,
 * while non-consolidated mode shows data for a specific company only.
 *
 * @returns Object containing reactive consolidated state
 */
export function useConsolidated() {
  const route = useRoute();

  const consolidated = computed(() => {
    return route.query.consolidated === "true";
  });

  return { consolidated };
}
